import { render } from "./TableHeaderCell.vue?vue&type=template&id=35755011&scoped=true&ts=true"
import script from "./TableHeaderCell.vue?vue&type=script&lang=ts"
export * from "./TableHeaderCell.vue?vue&type=script&lang=ts"

import "./table-header-cell.scss?vue&type=style&index=0&id=35755011&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35755011"]])

export default __exports__